import React, { useEffect } from "react";

import Main from '../components/Home/Main'
import TradeVar from "../components/Home/TradeVar";
import Diversity from "../components/Home/Diversity";
import DepositTake from "../components/Home/DepositTake";
import WeHaveTransparent from "../components/Home/WeHaveTransparent";
import YourTradingJourney from "../components/Home/YourTradingJourney";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">  
            <Main/>
            <TradeVar/>
            <Diversity/>
            <DepositTake/>
            <WeHaveTransparent/>
            <YourTradingJourney/>
        </div>
    );
}

export default Home;